export default class SupportedCurrencies {
    constructor(element) {
        this.selector = element;
        this.nav = element.querySelector('[data-sc-nav]');
        this.buttons = Array.from(element.querySelectorAll('[data-type-button]'));
        this.indicator = element.querySelector('[data-sc-indicator]');
        this.hoverIndicator = element.querySelector('[data-sc-hover-indicator]');
        this.hoveredIndex = -1;
        this.isTouching = false;

        this.open();
        this.initIndicators();
    }

    open() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const activeButton = this.selector.querySelector('[data-type-button].active-sc-tab');
                const activeContent = this.selector.querySelector('[data-type-content]:not(.hidden)');
                const content = this.selector.querySelector(`[data-type-content="${button.dataset.typeButton}"]`);

                if (activeButton) activeButton.classList.remove('active-sc-tab');
                if (activeContent) activeContent.classList.add('hidden');

                button.classList.add('active-sc-tab');
                if (content) content.classList.remove('hidden');

                const index = parseInt(button.dataset.typeButton, 10);
                this.positionIndicator(this.indicator, index);
            });
        });
    }

    initIndicators() {
        if (!this.nav || !this.buttons.length) return;

        this.nav.addEventListener('touchstart', () => { this.isTouching = true; }, { passive: true });
        this.nav.addEventListener('touchend', () => {
            setTimeout(() => { this.isTouching = false; }, 300);
        }, { passive: true });

        this.buttons.forEach((button, index) => {
            button.addEventListener('mouseenter', () => this.showHoverIndicator(index));
            button.addEventListener('focus', () => this.showHoverIndicator(index));
        });

        this.nav.addEventListener('mouseleave', () => this.hideHoverIndicator());
        this.nav.addEventListener('focusout', (e) => {
            if (!this.nav.contains(e.relatedTarget)) this.hideHoverIndicator();
        });

        // Position active indicator after paint
        requestAnimationFrame(() => {
            const activeIndex = this.buttons.findIndex((b) => b.classList.contains('active-sc-tab'));
            this.positionIndicator(this.indicator, activeIndex >= 0 ? activeIndex : 0);
        });

        window.addEventListener('resize', () => {
            const activeIndex = this.buttons.findIndex((b) => b.classList.contains('active-sc-tab'));
            this.positionIndicator(this.indicator, activeIndex >= 0 ? activeIndex : 0);
            if (this.hoveredIndex >= 0) this.showHoverIndicator(this.hoveredIndex);
        });
    }

    positionIndicator(target, index) {
        if (!target || !this.buttons[index]) return;
        const btn = this.buttons[index];
        target.style.width = btn.offsetWidth + 'px';
        target.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
    }

    showHoverIndicator(index) {
        if (this.isTouching || !this.hoverIndicator || !this.buttons[index]) return;
        this.hoveredIndex = index;
        this.positionIndicator(this.hoverIndicator, index);
        this.hoverIndicator.style.opacity = '1';
    }

    hideHoverIndicator() {
        this.hoveredIndex = -1;
        if (this.hoverIndicator) this.hoverIndicator.style.opacity = '0';
    }
}